import {
  FETCH_REPORT_FAILURE,
  FETCH_REPORT_REQUEST,
  FETCH_REPORT_SUCCESS,
} from "./reportActionType";

const initialState = {
  ReportData: [],
  loading: false,
  error: null,
};

const ReportReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_REPORT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        ReportData: action.payload  || [],  
      };
    case FETCH_REPORT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        ReportData:[]
      };
    default:
      return state;
  }
};

export default ReportReducer;
